import React, { forwardRef, useCallback, useEffect, useState } from "react";
import {  Form, Stack } from "rsuite";
import { unescapeConfigString } from "../../common/utils";

const CheckboxWithErrorStatus = React.memo(forwardRef(
    (
        {
            showError,
            value,
            onChange,
            ...props
        },
        ref
    ) => {
        const [ignoreError, setIgnoreError] = useState(false);

        useEffect(() => {
            setIgnoreError(false)
        }, [])

        const changedInternal = (v, doIgnoreError = true) => {
            setIgnoreError(doIgnoreError && (v === true));
            onChange(v)
        }

        return (
            <div>
                <label className={`checkbox style-d`}>
                    <input 
                        ref={ref} 
                        type="checkbox" 
                        onChange={(e) => changedInternal(e.target.checked)}
                        checked={value ?? false} 
                        {...props}
                    />
                    <div className={`checkbox__checkmark ${showError && !ignoreError ? "checkbox-invalid" : ""}`}></div>
                </label>
            </div>
        )
    }
))

const AnnotatedCheckbox = ({
    title, 
    label, 
    name, 
    annotation = () => null, 
    validationRule,
    style, 
    hasError,
    ...rest}) => {

    const CheckboxWithErrorStateAndProps = useCallback(
        (props) => (
            <CheckboxWithErrorStatus
                {...props}
                showError={hasError}
            />
        ),
        [hasError]
    )

    return (
        <>
            <Form.Group controlId={name} style={style}>
                {title && <Form.ControlLabel>{title}</Form.ControlLabel>}
                
                <Stack className="mt-8" direction="column" alignItems="flex-start">
                    <Stack.Item>
                        <Stack direction="row" alignItems="center" spacing={4}>
                            <Stack.Item>
                                <Form.Control 
                                    accepter={CheckboxWithErrorStateAndProps}
                                    name={name} 
                                    checkTrigger="none"
                                    rule={validationRule}
                                    {...rest}
                                />
                            </Stack.Item>
                            <Stack.Item className="mt-4">
                                <Form.ControlLabel id={`${name}-label`}>{label}</Form.ControlLabel>
                            </Stack.Item>
                        </Stack>
                    </Stack.Item>   
                    {annotation()}
                </Stack>
            </Form.Group>
        </>
    )
}

export default AnnotatedCheckbox;